export const isReady = (insights) => !!insights?.ready &&
    !!insights.categoryComparison &&
    !!insights.topMerchants &&
    !!insights.subscriptions;
export const selectSpendingInsights = (store) => store.onboardingInsights.spendingInsights;
/** The insights only when every screen can be rendered from them. */
export const selectReadySpendingInsights = (store) => {
    const insights = selectSpendingInsights(store);
    return isReady(insights) ? insights : undefined;
};
